var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined-Bold/Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconVector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.5C4 2.94772 4.44772 2.5 5 2.5H19C19.5523 2.5 20 2.94772 20 3.5C20 4.05228 19.5523 4.5 19 4.5H5C4.44772 4.5 4 4.05228 4 3.5ZM11.2929 6.79289C11.6834 6.40237 12.3166 6.40237 12.7071 6.79289L15.7071 9.79289C16.0976 10.1834 16.0976 10.8166 15.7071 11.2071C15.3166 11.5976 14.6834 11.5976 14.2929 11.2071L13 9.91421V21.5C13 22.0523 12.5523 22.5 12 22.5C11.4477 22.5 11 22.0523 11 21.5V9.91421L9.70711 11.2071C9.31658 11.5976 8.68342 11.5976 8.29289 11.2071C7.90237 10.8166 7.90237 10.1834 8.29289 9.79289L11.2929 6.79289Z",
    fill: "#033272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBtn);
export default __webpack_public_path__ + "static/media/upload-btn.7a07aecdc743180007768d0ad3747453.svg";
export { ForwardRef as ReactComponent };